import type { CSSProperties } from 'react';

/**
 * Carrier portal action-button label typography.
 * Matches My Loads Actions (font-weight 500, 14px). Typography only.
 */
export const CARRIER_ACTION_BUTTON_TEXT_STYLE: CSSProperties = {
  fontFamily: 'inherit',
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 'normal'
};
